import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { OrderProtectionExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { TypedRuleGroup } from '@app/sharedModule/components/rules-dynamic-form/model';

export { OrderProtectionExtension };

export const USAGE_TOKEN_PREFIX = 'order_protection_';
export const USAGE_TOKEN_RANDOM_LENGTH = 12;
export const DEFAULT_INTERNAL_NAME = 'Order Protection';
export const DEFAULT_INTERNAL_DESCRIPTION = 'Offer shipping protection at checkout';
export const DEFAULT_TITLE_TEXT = 'Order Protection';
export const DEFAULT_INFO_TEXT = 'Protect your order';
export const DEFAULT_DISCLAIMER_TEXT =
  'By leaving the toggle selected, I agree to include shipping insurance for added protection and priority support. I understand this will be added to my order at checkout.';
export const DEFAULT_FIXED_RATE = 3;
export const DEFAULT_PERCENTAGE_RATE = 2;

export enum OrderProtectionTab {
  SETTINGS = 'settings',
  PRICING = 'pricing',
  APPEARANCE = 'appearance',
  DISPLAY_CONDITIONS = 'display_conditions',
}

export interface OrderProtectionProductInfo {
  found: boolean;
  productId: string | null;
  title: string | null;
  imageUrl: string | null;
  tierCount: number;
  minPrice: number | null;
  maxPrice: number | null;
}

export type OrderProtectionProductState = 'loading' | 'not_connected' | 'not_found' | 'found';

export interface OrderProtectionProductView {
  state: OrderProtectionProductState;
  productId: string | null;
  imageUrl: string | null;
  title: string | null;
  meta: string | null;
}

export interface WidgetConfigFormGroup {
  titleText: FormControl<string>;
  titleTextBold: FormControl<boolean>;
  titleTextSize: FormControl<OrderProtectionExtension.TextSize>;
  infoText: FormControl<string>;
  infoTextSize: FormControl<OrderProtectionExtension.TextSize>;
  showInfoModal: FormControl<boolean>;
  actionButtonType: FormControl<OrderProtectionExtension.ActionType>;
  hideLogo: FormControl<boolean>;
  showDisclaimerText: FormControl<boolean>;
  disclaimerTextOn: FormControl<string>;
  disclaimerTextOnSize: FormControl<OrderProtectionExtension.TextSize>;
  showBorder: FormControl<boolean>;
  borderStyle: FormControl<OrderProtectionExtension.BorderStyle>;
  borderWidth: FormControl<OrderProtectionExtension.BorderWidth>;
  borderRadius: FormControl<OrderProtectionExtension.BorderRadius>;
  backgroundColor: FormControl<OrderProtectionExtension.BackgroundColor>;
}

export interface OrderProtectionFormGroup {
  usageToken: FormControl<string>;
  internalName: FormControl<string>;
  internalDescription: FormControl<string>;
  status: FormControl<OrderProtectionExtension.WidgetStatus>;
  automaticallyAddToCart: FormControl<boolean>;
  rateType: FormControl<OrderProtectionExtension.RateType>;
  rate: FormControl<number>;
  config: FormGroup<WidgetConfigFormGroup>;
  restrictionsRules: FormArray<FormGroup<TypedRuleGroup>>;
}
